<template>
  <div class="hello">

      <b-modal no-fade  id='modal-unsubscribed'  title="Unsubscribed" ok-only ok-title="OK" @ok="gotToHome()"
            header-bg-variant='info'
            header-text-variant="light"
        >
        You have been unsubscribed from Keg Seeker Post Offering emails
      </b-modal>

    <b-container>
        <b-row style="margin-top:40px">
            <b-col>
                <h2>Unsubscribe</h2>
            </b-col>
        </b-row>

        <b-row v-if="!invalidUid">
            <b-col>
                <b-button size="lg" class="m-md-2" variant="info" @click="unsubscribe()">
                    Unsubscribe from Post Offering emails
                </b-button>
            </b-col>
        </b-row>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {    
    props: {
        
    },

    computed: {
        ...mapState([])
    },

    components: {
    },

    data() {
        return {
            invalidUid:false,
            pubid:'',

        }
    },

    methods:{
        unsubscribe(){
            fb.unsubPostOffering.add({uid:this.pubid})
            this.$bvModal.show("modal-unsubscribed")
        },

        //Go to home after unsubscribe
        gotToHome(){
            this.$router.push('/login')
        }
    },

    mounted(){
        if (this.$route.params.unsubscribe ){
            this.pubid  = this.$route.params.unsubscribe
            console.log("Unsub pubid = " + this.pubid)
        } 
        
        else{
            this.invalidUid = true
            console.log("No Pubid in unsub")
        } 
    },
}
</script>

